import BaseNagivation from './Nagivation';

// EXPORT
export const Navigation = BaseNagivation;
export type { NavigationProps } from './Navigation.interface';
